
import { defineComponent } from "vue"
import MatchPoolsIndex from "@/components/match_pools/Index.vue"

export default defineComponent({
  components: {
    MatchPoolsIndex
  }
})
